import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from '@shared/services/theme.service';
import { UserPreferencesService, UserPreferences } from '@shared/services/usuario/user-preferences.service';
import { NotificationService } from '@shared/services/notificacion/notification.service';

@Component({
  selector: 'app-theme-toggle-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-toggle-button.component.html',
})
export class ThemeToggleButtonComponent {
  private themeService = inject(ThemeService);
  private userPreferencesService = inject(UserPreferencesService);
  private notification = inject(NotificationService);
  private transloco = inject(TranslocoService);

  // Ahora usamos la signal directamente, sin $
  theme = this.themeService.theme;

  toggleTheme() {
    this.themeService.toggleTheme();

    // Cambia SOLO el tema, conservando el resto de preferencias del usuario (idioma, zona
    // horaria, moneda, notificaciones). Antes se enviaba `language: 'es'` fijo, lo que pisaba
    // el `null` heredado y forzaba español aunque la organización estuviera en inglés.
    const base = this.userPreferencesService.preferences();
    const prefs: UserPreferences = {
      ...(base ?? { theme: this.theme(), language: null, notificationsEnabled: true }),
      theme: this.theme(),
    };

    this.userPreferencesService.updatePreferences(prefs).subscribe({
      next: () => {
        this.notification.success(
          this.transloco.translate('layout.themeSaved.title'),
          this.transloco.translate('layout.themeSaved.message')
        );
      },
      error: () => {
      }
    });
  }
}
